// src/portals/admin/pages/OpportunitiesHubPage.js
import React from "react";
import { useData } from "../../../context/DataContext";
import AdManager from "../components/monetization/AdManager";
import AffiliateManager from "../components/monetization/AffiliateManager";
import DonationManager from "../components/monetization/DonationManager";

const OpportunitiesHubPage = ({ type = "ads" }) => {
  // Use data from context instead of local state/mock
  const { adCampaigns, affiliates, donations } = useData();

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-slate-800">Monetization Hub</h1>
          <p className="text-slate-500 mt-1">
            Manage platform-wide monetization opportunities including Ads, Affiliates, and Donations.
          </p>
        </div>
      </div>
      
      {type === "ads" && <AdManager />}
      {type === "affiliates" && <AffiliateManager />}
      {type === "donations" && <DonationManager />}
    </div>
  );
};

export default OpportunitiesHubPage;
